<div class="main-imers-header">
<div class="impersonate-div">
    <div class="impersonate-txt">You are logged in as {{userName}} but are impersonating {{impersonatedUser}}</div>
   
        <app-button  label="Exit Impersonation Mode"
               [isFilled]="false" [buttonType]="'primary'"
               (click)="stopImpersonate()" id="btnImpersoante" class="exit-impersonation imprt-btn"></app-button>

</div>
</div>
